import { Component, OnInit, ViewChild} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { LineBotService } from '../../_services/line-bot.service';
import { UserQuestionsService } from '../../_services/user-questions.service';
import { ReplyQuestionComponent } from './reply-question/reply-question.component';
import { DataTableDirective } from 'angular-datatables';
import { DialogService } from "ng2-bootstrap-modal";
import { ConfirmComponent } from '../../_common/confirm/confirm.component';

@Component({
    selector: 'app-user-questions',
    templateUrl: './user-questions.component.html',
    styleUrls: ['./user-questions.component.css']
})
export class UserQuestionsComponent implements OnInit {

    users: any;
    searchWord: string;
    delayTimer: any;
    dtOptions: DataTables.Settings = {};
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;

    //declare parameters object
    parameters: any = {};
    //declare callback object
    callback: any = {};
    filterBy = 2; // default display all question

    lineBotAlls: Observable<any[]>;
    lineBotId: number = 6; // default Bitlion Pro Bot

    constructor(
        private userQuestionService: UserQuestionsService,
        private lineBotService: LineBotService,
        private dialogService: DialogService
    ) {
    }

    ngOnInit() {
        this.initDataTables();
    }

    initDataTables() {
        let self = this;
        this.lineBotAlls = this.lineBotService.getLineBot();
        this.dtOptions = {
            language: {
                emptyTable: "データが存在しません"
            },
            order: [[4, "desc"]],// default sort by time_asked
            searching: false,
            lengthChange: false,
            serverSide: true,
            pageLength: 15,
            ajax: function (parameters, callback, settings) {
                parameters["search"]["value"] = self.searchWord || '';

                if (self.filterBy == 1) {
                    parameters["search"]["status"] = 1;
                } else if (self.filterBy == 0) {
                    parameters["search"]["status"] = 0;
                }

                //assign parameters object
                self.parameters = parameters;
                //assign callback object
                self.callback = callback;

                self.lineBotAlls.subscribe(dataLineBot => {
                    if (dataLineBot && dataLineBot.constructor === Array && dataLineBot.length) {
                        parameters["search"]["line_bot_id"] = self.lineBotId || dataLineBot[0].id;
                        self.userQuestionService.gets(parameters).subscribe(result => {
                            callback({
                                draw: parameters['draw'],
                                data: result.data,
                                recordsTotal: result.data.length,
                                recordsFiltered: result.recordsTotal
                            });
                        });
                    }
               });
            },
            columns: [
                {
                    title: 'ID',
                    data: 'id',
                    name: 'id',
                    width: '5%',
                },
                {
                    title: "Lineユーザーネーム",
                    width: '10%',
                    data: "display_name",
                    name: "display_name",
                },
                {
                    title: "質問",
                    width: '24%',
                    data: function (data) {
                        return '<div><pre>' + (data.question != null ? data.question : '') + '</pre></div>'
                    },
                    name: "question",
                },
                {
                    title: "回答",
                    width: '24%',
                    data: function (data) {
                        return '<div><pre>' + (data.answer != null ? data.answer : '') + '</pre></div>'
                    },
                    name: "answer",
                },
                {
                    title: "質問した時間",
                    data: "time_asked",
                    name: "time_asked",
                    width: '8%',
                },
                {
                    title: "回答した時間",
                    data: "time_replied",
                    name: "time_replied",
                    width: '8%',
                },
                {
                    title: "ステータス",
                    data: "span_status",
                    width: '7%',
                    className: "all text-center",
                    orderable: false
                },
                {
                    title: "",
                    data: function () {
                        return `<button class="btn btn-sm btn-danger btn-delete">削除</button>`;
                    },
                    width: '6%',
                    className: "all text-center",
                    orderable: false
                },
                {
                    title: "",
                    width: '6%',
                    data: function (d) {
                        return `<button class="btn btn-small btn-reply" style="background-color: #337ab7; color:white">回答する</button>`;
                    },
                    orderable: false,
                    className: "all text-justify"
                }
            ],
            rowCallback: (row: Node, data: any[] | Object, index: number) => {
                $('.btn-reply', row).bind('click', () => {
                    self.openModalReply(data);
                });
                $('.btn-delete', row).bind('click', () => {
                    self.confirmDelete(data);
                });
                $('.btn', row).css({
                    'font-size': '11px',
                    'margin-left': '-1px',
                    'padding': '4px 5px'
                });
                $('th', row).css({
                    'font-size': '1px'
                });
                var span_status = $(row).find('td').find('.label-status');
                span_status.css({
                    'padding': '7px 5px',
                    'font-weight': 'normal',
                    'font-size': '11px',
                    'display': 'block',
                    'margin-left': '-1px'
                });
                var td_row = $(row).find('td');
                td_row.css({
                    'word-wrap': 'break-word'
                });
                var pre_css = $(row).find('pre');
                pre_css.css({
                    'white-space': 'pre-wrap', /* Since CSS 2.1 */
                    'word-wrap': 'break-word', /* Internet Explorer 5.5+ */
                    'border': 'none',
                    'background-color': 'inherit',
                    'word-break': 'normal'
                });
                var div_style = $(row).find('div');
                div_style.css({
                    'max-height': '200px',
                    'overflow': 'auto',
                });

               return row;
            }
        };
    }

    valuechange(newValue) {
        this.searchWord = newValue;
        this.doSearch();
    }

    onChangeFilter(event) {
        this.filterBy = event.target.value;
        this.rerenderDataTable();
    }

    doSearch() {
        let self = this;
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(function () {
            self.rerenderDataTable();
        }, 600);
    };

    rerenderDataTable(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
        });
    }

    openModalReply(data) {
        this.dialogService.addDialog(ReplyQuestionComponent, {
            id: data.id,
            question: data.question,
            answer: data.answer,
            uid: data.uid,
            lineBotId: data.line_bot_id
        }).subscribe((isAccess) => {
            if (isAccess) {
                this.loadCurrentPage();
            }
        });
    }

    loadCurrentPage() {
        //get parameters and retrive result of current page 
        this.userQuestionService.gets(this.parameters).subscribe(result => {
            //use callback function
            this.callback({
                //retrive draw current
                draw: this.parameters['draw'],
                //retrive data of current page
                data: result.data,
                //retrive number records per page
                recordsTotal: result.data.length,
                //retrive total records
                recordsFiltered: result.recordsTotal
            });
        });
    }

    // change value line_bot_id
    onChangeLineBot(event) {
        this.lineBotId = event.target.value;
        this.rerenderDataTable();
    }

    confirmDelete(data) {
        this.dialogService.addDialog(ConfirmComponent, {
            title: '確認',
            message: '削除しますが、よろしいでしょうか？'
        }).subscribe((isConfirmed) => {
            if (isConfirmed) {
                this.userQuestionService.delete(data.id).subscribe(data => {
                    this.loadCurrentPage();
                }, error => {

                });
            }
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/user-questions/user-questions.component.ts